import React, { useEffect, useRef } from "react";
import { useAlarm } from "../context/Alarmcontext";

/**
 * Legacy global exercise alarm gate. Training cues now play via
 * `utils/exerciseTimerSounds.js` (iOS SoundManager parity). Kept mounted
 * so older callers of AlarmContext do not crash.
 */
const Alarm = () => {
  const { isPlaying, setIsPlaying } = useAlarm();
  const armedRef = useRef(false);

  useEffect(() => {
    if (!isPlaying) {
      armedRef.current = false;
      return undefined;
    }
    if (armedRef.current) return undefined;
    armedRef.current = true;
    const t = setTimeout(() => setIsPlaying(false), 50);
    return () => clearTimeout(t);
  }, [isPlaying, setIsPlaying]);

  return null;
};

export default Alarm;
